import { render, staticRenderFns } from "./ProductStockLabelPopUp.vue?vue&type=template&id=84ce0608&scoped=true&"
import script from "./ProductStockLabelPopUp.vue?vue&type=script&lang=js&"
export * from "./ProductStockLabelPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ProductStockLabelPopUp.vue?vue&type=style&index=0&id=84ce0608&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ce0608",
  null
  
)

export default component.exports